import { Component, computed, input } from '@angular/core';
import { WheelPrize } from '../../models/wheel-of-fortune.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-wheel-trophy',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './wheel-trophy.component.html',
  styleUrl: './wheel-trophy.component.scss'
})
export class WheelTrophyComponent {
  public data = input.required<WheelPrize | null>();

  public header = computed(() => this.calculateHeader());

  private calculateHeader() {
    if (this.data()?.type === 'product') {
      return 'WHEEL.TROPHY.HEADER';
    }
    return (this.data()?.name as number) > 0 ? 'WHEEL.TROPHY.HEADER' : 'WHEEL.TROPHY.HEADER_FAILURE';
  }

  public get showExpDate(): boolean {
    const dataType = this.data()?.type;
    if (dataType !== 'bonuses') {
      return true;
    }
    if (dataType === 'bonuses' && this.data()?.name as number > 0) {
      return true;
    }
    return false;
  } 
}
